import React from "react";
import { useHistory } from "react-router-dom";
import { BiChevronDown } from "react-icons/bi";
import Logo from "../assets/images/normal_logo.png";
import { useAuth } from "../services/authProvider";
import { useUserProfile } from "../hooks/getUserProfile";

const Navbar = ({ isPageRole }) => {
  const { logout } = useAuth();
  const history = useHistory();
  const { data: userProfile } = useUserProfile();

  const handleLogout = () => {
    logout();
    // Redirect to login page after logout
    setTimeout(() => {
      history.push("/user/login");
    }, 100);
  };

  // Get user display information
  const firstName = userProfile?.data?.firstName || "";
  const lastName = userProfile?.data?.lastName || "";
  const position =
    userProfile?.data?.careProvider?.position?.abbreviation || "";

  return (
    <nav className="navbar navbar-expand-lg navbar-white bg-white shadow-sm px-5">
      <a className="navbar-brand" href="#">
        <img src={Logo} className="img-fluid" width={118} height={48} alt="" />
      </a>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        {!isPageRole && (
          <ul className="navbar-nav ml-auto">
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle navbar-btn px-2 rounded d-flex align-items-center justify-content-center text_small text-decoration-none"
                style={{ minHeight: 36, padding: "4px 8px" }}
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="d-flex flex-column align-items-start mr-2">
                  <span style={{ fontSize: "13px", lineHeight: "1.2" }}>
                    {firstName && lastName
                      ? `${lastName}, ${firstName}`
                      : "User"}
                  </span>
                  {position && (
                    <span
                      style={{
                        fontSize: "13px",
                        lineHeight: "1.2",
                      }}
                    >
                      {position}
                    </span>
                  )}
                </div>
                <BiChevronDown size={30} className="navbar-btn-icon" />
              </a>
              <div
                className="dropdown-menu dropdown-menu-right w-small pl-0 ml-0"
                aria-labelledby="navbarDropdown"
              >
                <a className="dropdown-item ml-0 pl-3 text_small" href="#">
                  <i className="fa fa-user" /> &nbsp;Profile
                </a>
                <a className="dropdown-item ml-0 pl-3 text_small" href="#">
                  <i className="fa fa-key" /> &nbsp;Change Password
                </a>
                <a
                  className="dropdown-item ml-0 pl-3 text_small"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                >
                  <i className="fa fa-sign-out" /> &nbsp;Logout
                </a>
              </div>
            </li>
          </ul>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
